import { DataType } from '@/core/data/DataType';
import { FView } from '@/core/FView';
import { DashboardTabWrapper } from './DashboardTabWrapper';

export class DashboardTabs {
    private static REGISTERED_TABS : DashboardTabWrapper[] = [];

    public static RegisterTab(tab: DashboardTabWrapper): void {
        this.REGISTERED_TABS.push(tab);
    }
/*
    private static hasAny(types:DataType[]) : boolean {
        return types.some(type => FView.Get().dataManager.HasDataset(type));
    }
*/
    private static hasAll(types:DataType[]) : boolean {
        return types.every(type => FView.Get().dataManager.HasDataset(type));
    }

    public static GetAvailable() : DashboardTabWrapper[] {
        let tabs: DashboardTabWrapper[] = [];
        for (let tab of this.REGISTERED_TABS) {
            if (this.hasAll(tab.requiredTypes) && tab.canBeDisplayed()) {
                tabs.push(tab);
            }
        }
        return tabs;
    }

    public static GetDisplayedTab(tabs: DashboardTabWrapper[]): number {
        for (let i in tabs) {
            if (tabs[i].isDisplayed()) {
                return Number(i);
            }
        }
        return 0;
    }
}

// REQUIRE ALL USED TAB .VUE-FILES HERE!!!
require('./TabVisitors.vue');
require('./TabEntranceDistribution.vue');
require('./TabEnterExit.vue');
